// Hero composition shared between the marketing LP and the onboarding overlay.
// Big tilted ticket + floating mini tickets + sparkles.

import React, { CSSProperties } from "react";
import { PictX, Sparkle } from "./shared";

type Props = { brand: string; accent: string };

export const OnboardingHero: React.FC<Props> = ({ brand, accent }) => (
  <div style={{ position: "relative", width: 280, height: 300 }}>
    <MiniTicket style={{ top: 24, left: -4 }} rotate={-22} band="#3DBED9" delay={120} />
    <MiniTicket style={{ top: 56, right: -10 }} rotate={16} band="#FFC325" delay={200} />
    <MiniTicket style={{ bottom: 76, left: -16 }} rotate={-14} band="#0FAC6D" delay={280} />
    <MiniTicket style={{ bottom: 36, right: -6 }} rotate={12} band={brand} delay={340} />

    <div
      data-boomin-anim
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: 224,
        animation: "boom-fly-up 600ms 60ms ease-out backwards",
      }}
    >
      <div
        data-boomin-anim
        style={{
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 22px 40px rgba(0,0,0,0.18)",
          overflow: "hidden",
          transform: "rotate(-6deg)",
          animation: "boom-wiggle 5s 700ms ease-in-out infinite",
          transformOrigin: "center",
        }}
      >
        <div
          style={{
            background: `linear-gradient(135deg, ${brand} 0%, ${accent} 100%)`,
            padding: "14px 16px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 200 80"
            preserveAspectRatio="none"
            style={{ position: "absolute", inset: 0, opacity: 0.2 }}
          >
            <circle cx="170" cy="20" r="30" fill="#fff" />
            <circle cx="140" cy="65" r="16" fill="#fff" />
          </svg>
          <div style={{ position: "relative" }}>
            <div
              style={{
                display: "inline-flex",
                background: "rgba(255,255,255,0.28)",
                color: "#fff",
                fontSize: 9,
                fontWeight: 800,
                padding: "3px 8px",
                borderRadius: 999,
                backdropFilter: "blur(4px)",
                marginBottom: 6,
                letterSpacing: "0.04em",
              }}
            >
              今だけ
            </div>
            <div style={{ color: "#fff", fontSize: 17, fontWeight: 800, lineHeight: 1.25 }}>
              ランチ
              <br />
              オプション無料
            </div>
          </div>
        </div>

        <div style={{ position: "relative", height: 14 }}>
          <div
            style={{
              position: "absolute",
              left: -7,
              top: 0,
              bottom: 0,
              width: 14,
              borderRadius: "50%",
              background: "#FFF3E0",
            }}
          />
          <div
            style={{
              position: "absolute",
              right: -7,
              top: 0,
              bottom: 0,
              width: 14,
              borderRadius: "50%",
              background: "#FFF3E0",
            }}
          />
          <div
            style={{
              position: "absolute",
              left: 10,
              right: 10,
              top: "50%",
              borderTop: "1.5px dashed #E5DBD0",
            }}
          />
        </div>

        <div
          style={{
            padding: "10px 16px 14px",
            display: "flex",
            justifyContent: "space-between",
            fontSize: 10,
            color: "#777",
            fontWeight: 700,
          }}
        >
          <span>ECO FARM CAFE 632</span>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
            <PictX name="walk" size={11} stroke="#777" strokeWidth={1.9} />
            徒歩4分
          </span>
        </div>
      </div>
    </div>

    <Sparkle style={{ top: "8%", left: "12%" }} delay={120} color="#FFC325" />
    <Sparkle style={{ top: "18%", right: "8%" }} delay={420} color={brand} />
    <Sparkle style={{ top: "48%", left: "-2%" }} delay={760} color="#3DBED9" size={12} />
    <Sparkle style={{ bottom: "18%", left: "14%" }} delay={300} color="#FFC325" size={14} />
    <Sparkle style={{ bottom: "8%", right: "10%" }} delay={600} color={brand} />
    <Sparkle style={{ top: "38%", right: "-2%" }} delay={900} color="#FFC325" size={12} />
  </div>
);

type MiniTicketProps = {
  style?: CSSProperties;
  band: string;
  rotate?: number;
  delay?: number;
};

const MiniTicket: React.FC<MiniTicketProps> = ({
  style,
  band,
  rotate = 0,
  delay = 0,
}) => (
  <div
    data-boomin-anim
    style={{
      position: "absolute",
      width: 72,
      height: 42,
      background: "#fff",
      borderRadius: 9,
      boxShadow: "0 8px 16px rgba(0,0,0,0.12)",
      display: "flex",
      transform: `rotate(${rotate}deg)`,
      animation: `boom-fly-up 600ms ${delay}ms ease-out backwards`,
      overflow: "hidden",
      ...style,
    }}
  >
    <div style={{ width: 18, background: band, position: "relative" }}>
      <div
        style={{
          position: "absolute",
          right: -4,
          top: "50%",
          transform: "translateY(-50%)",
          width: 7,
          height: 7,
          borderRadius: "50%",
          background: "#fff",
        }}
      />
    </div>
    <div style={{ flex: 1, padding: "6px 8px" }}>
      <div
        style={{
          height: 4,
          background: "#F0E6DC",
          borderRadius: 2,
          marginBottom: 4,
          width: "85%",
        }}
      />
      <div
        style={{
          height: 4,
          background: "#F0E6DC",
          borderRadius: 2,
          marginBottom: 4,
          width: "55%",
        }}
      />
      <div
        style={{
          height: 3,
          background: band,
          opacity: 0.6,
          borderRadius: 2,
          width: "40%",
        }}
      />
    </div>
  </div>
);
